/**
 * User List — who's in the channel (Talk2 light theme).
 */
import React from 'react';
import { Users } from 'lucide-react';
import useStore from '../store/useStore';

const EMPTY_ARRAY = [];

export default function UserList({ channelId }) {
  const channelUsers = useStore(s => s.channelUsers[channelId] ?? EMPTY_ARRAY);
  const isTransmitting = useStore(s => s.isTransmitting);
  const transmittingUser = useStore(s => s.transmittingUser);
  const currentUser = useStore(s => s.user);

  return (
    <div className="flex flex-col h-full"
      style={{ background: 'rgba(255,255,255,0.5)' }}>
      <div className="px-4 py-3 flex items-center gap-2 flex-shrink-0"
        style={{ borderBottom: '1px solid rgba(0,0,0,0.06)' }}>
        <Users size={13} className="text-n-500" />
        <span className="text-[10px] font-bold uppercase tracking-widest text-n-500">
          En canal ({channelUsers.length})
        </span>
      </div>

      <div className="flex-1 overflow-y-auto scrollbar-thin p-2 space-y-1">
        {channelUsers.length === 0 ? (
          <div className="text-center py-8 text-xs text-n-400">
            Nadie en este canal
          </div>
        ) : (
          channelUsers.map((u, idx) => {
            const isCurrentUser = u.userId === currentUser?.id;
            const isTx = isTransmitting && transmittingUser?.userId === u.userId;
            const hue = u.avatarColor || '#007AFF';

            return (
              <div key={u.userId || idx}
                className={`flex items-center gap-2.5 px-2.5 py-2 rounded-md transition-all duration-200 ${
                  isTx ? 'animate-fade-in' : ''
                }`}
                style={isTx ? {
                  background: '#FFE5EC',
                  boxShadow: '0 4px 12px rgba(255,45,85,.18)',
                } : { background: 'transparent' }}>

                {/* Avatar */}
                <div className="relative flex-shrink-0">
                  <div className="w-9 h-9 rounded-full flex items-center justify-center text-xs font-bold text-white shadow-apple-sm"
                    style={{
                      background: `linear-gradient(135deg, ${hue}, #AF52DE)`,
                      boxShadow: isTx ? `0 0 14px ${hue}99` : '0 1px 2px rgba(0,0,0,0.06)',
                    }}>
                    {u.username?.[0]?.toUpperCase() || '?'}
                  </div>
                  {/* Online dot */}
                  <div className="absolute -bottom-0.5 -right-0.5 w-2.5 h-2.5 rounded-full"
                    style={{
                      background: isTx ? '#FF2D55' : '#34C759',
                      border: '2px solid #FFF',
                      boxShadow: isTx ? '0 0 6px rgba(255,45,85,0.7)' : '0 0 4px rgba(52,199,89,0.45)',
                    }} />
                </div>

                {/* Name */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-1">
                    <span className={`text-xs font-semibold truncate tracking-apple-tight ${
                      isCurrentUser ? 'text-s-blue' : 'text-n-800'
                    }`}>
                      {u.username}{isCurrentUser ? ' (tú)' : ''}
                    </span>
                  </div>
                  {isTx && (
                    <div className="flex items-center gap-1 mt-0.5">
                      <div className="flex gap-0.5 items-end h-3">
                        {[0,1,2,3,4].map(i => (
                          <div key={i} className="w-0.5 rounded-sm"
                            style={{
                              background: '#FF2D55',
                              height: '100%',
                              animationName: 'wave',
                              animationDuration: `${0.5 + i * 0.1}s`,
                              animationTimingFunction: 'ease-in-out',
                              animationIterationCount: 'infinite',
                              animationDelay: `${i * 0.05}s`,
                              transform: 'scaleY(0.4)',
                            }} />
                        ))}
                      </div>
                      <span className="text-[10px] font-bold tracking-widest" style={{ color: '#FF2D55' }}>TX</span>
                    </div>
                  )}
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}
